import { PaymentMethodCard } from 'grabbitbot-legacy-ui'
import { paymentClient } from '../../api'

/** Equivalent of legacy `PaymentMethodViewComponent`. */
export function PaymentMethodPage() {
  return (
    <div>
      <h1>Payment method</h1>
      <PaymentMethodCard payment={paymentClient} className="screener-card" />
    </div>
  )
}
